import { render, staticRenderFns } from "./new-kanban-viewer.vue?vue&type=template&id=2de813b4&scoped=true"
import script from "./new-kanban-viewer.vue?vue&type=script&lang=ts"
export * from "./new-kanban-viewer.vue?vue&type=script&lang=ts"
import style0 from "./new-kanban-viewer.vue?vue&type=style&index=0&id=2de813b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de813b4",
  null
  
)

export default component.exports